<template lang="pug">
    v-container(grid-list-md v-if="content" )
        v-layout(wrap)
            v-flex(lg6 md6 xs12)
                v-text-field(dense v-model="source" label="No. Rekening Sumber" readonly)
                    template(v-slot:prepend)
                        v-icon(color="warning") mdi-credit-card-multiple-outline
            v-flex(lg5 md5 xs12)
                v-text-field(dense v-model="content.summary.productDescription.toUpperCase()" label="Jenis Transaksi" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-checkbox-marked-outline
            v-flex(lg6 md6 xs12 v-if="content.note")
                v-text-field(dense v-model="content.note" label="Berita" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-note-text-outline
            v-flex(lg5 md5 xs12 v-if="content.customerRef")
                v-text-field(dense v-model="content.customerRef" label="No. Dokumen" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-file-document-outline
            v-flex(lg12 md12 xs12)
                v-layout(wrap)
                    v-flex(lg3 md3 xs12)
                        f-decimalbox(v-model="content.summary.amount" label="Nominal" readonly :template="true")
                    v-flex(lg2 md2 xs12)
                        f-decimalbox(v-model="content.summary.fee" label="Biaya Admin" readonly :template="true")
                    v-flex(lg3 md3 xs12)
                        f-decimalbox(v-model="content.summary.totalAmount" label="Total" readonly :template="true")
            v-flex(lg12 md12 xs12)  
                v-row(class="primary--text subtitle-text justify-center text-center menu-btn-sm" dense)
                    div DAFTAR TRANSFER
                v-data-table(
                    dense
                    hide-default-footer
                    :headers="headers" 
                    :loading="loading"
                    loading-text="Proses mengambil data ....."
                    no-data-text="Data tidak ditemukan ....."
                    no-results-text="Data tidak ditemukan ....."
                    :items="listDetail"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    @page-count="pageCount = $event"
                    :search="criteria"
                )
                    template(v-slot:item.account="{item}")
                        v-chip(small :color="item.valid ? 'info' : 'error'" class="my-1") {{item.account | accountformat}}
                    template(v-slot:item.amount="{item}") 
                        div {{Number(item.amount) | decimalformat}}
                div(class="justify-end text-right ma-2")
                    div(class="subtitle-text primary--text")
                        v-layout(row)
                            v-flex(lg6 md6 xs6) Jumlah Detail Transaksi : {{listDetail.length}}
                            v-flex(lg6 md6 xs6) Total Nominal Transaksi : {{sumData | decimalformat}}
                div(class="text-xs-center ma-2")
                    v-pagination(v-model="page" :length="pageCount")
</template>
<script>
export default {
    name: "FMultiTransferInternalContent",
    props: ["content", "request", "transaction"],
    computed: {
        source() {
            return this.$options.filters.accountformat(this.content.source)+ " - " + this.content.sourceName;
        },
        sumData(){
            if (this.listDetail.length > 0) {
                return this.listDetail.map(m => m.amount).reduce((a,b) => a + b);
            }else{
                return 0;
            }
        }
    },
    watch: {
        content(val){
            if(val){
                if (this.request && this.request.data) {
                    this.listDetail = this.request.data.detail || [];
                }
            }
        },
        request(val){
            if(val && val.data){
                this.listDetail = this.request.data.detail || [];
            }
        }
    },
    mounted() {
        if(this.request && this.request.data){
            this.listDetail = this.request.data.detail || [];
        }
    },
    data() {
        return {
            listDetail: [],
            loading: false,
            criteria: "",
            headers: [
                {text: 'NO. REKENING', value: 'account', sortable: false, width: "130px", align:"center", class: "primary--text"},
                {text: 'NAMA REKENING', value: 'name', sortable: false, class: "primary--text"},
                {text: 'NOMINAL', value: 'amount', sortable: false, width: "110px", align:"right", class: "primary--text"},
            ],
            page: 1,
            itemsPerPage: 5,
            pageCount: 0,
        }
    },
};
</script>